import { Theme } from "@emotion/react";

export const theme: Theme = {
  grey: "rgb(112,112,112)",
  lightgrey: "rgb(171,167,163)",
  gold: "rgb(155, 135, 80)",
};

export default theme;
